import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Best15Section from "./components/Best15Section";
import HostStorySection from "./components/HostStorySection";
import BookingGuideSection from "./components/BookingGuideSection";
import TrustBuilderSection from "./components/TrustBuilderSection";
import FooterSection from "./components/FooterSection";

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <Best15Section />
      <HostStorySection />
      <BookingGuideSection />
      <TrustBuilderSection />
      <FooterSection />
    </div>
  );
}
